import { render, staticRenderFns } from "./account-setup.component.vue?vue&type=template&id=ab009d94"
import script from "./account-setup.component.ts?vue&type=script&lang=ts&external"
export * from "./account-setup.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports